import _ from 'lodash';
import * as actionTypes from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';
import {normalize} from '../../util/utils';

export function aresFormHeadersReducer(state = initialstate.aresFormHeaders, action) {
	let newState;

	switch (action.type) {
		case actionTypes.GET_ALL_TASKS_OVERVIEW: {
			if (action.responseObj.status === HttpStatusCodes.Ok && action.response) {
				const responseHeaders = action.response.headers || [];
				const responseSections =
					action.response.sections?.map((section) => {
						const existingSection = state?.sections?.byId[section?.id];
						const currentSection = existingSection || section;
						return {
							...currentSection,
							name: existingSection ? existingSection.name : section?.formSectionName,
							isDuplicate: section?.isDuplicate ?? section?.hasDuplicate,
						};
					}) || [];

				const headersList = responseHeaders?.map((header) => {
					const headerSections = responseSections.filter((section) => section?.formHeaderId === header.id);
					const sectionCount = headerSections?.length || 0;

					return {
						...header,
						name: header.formHeaderName,
						sections: sortedSections(headerSections).map((header) => header.id),
						firstSectionId: headerSections.find((section) => section?.isDisplayed)?.id,
						knowledgeFormHeaderId: header.knowledgeFormHeaderId,
						hideHeader:
							sectionCount === 0 || headerSections.every((section) => !section?.isDisplayed || section?.isSummary),
						hasSummarySection: headerSections.some((section) => section?.isDisplayed && section?.isSummary)
					};
				});

				newState = {
					headers: normalize(headersList, undefined, state.headers),
					sections: normalize(responseSections, undefined, state.sections)
				};

				break;
			}

			return state;
		}
		case actionTypes.GET_FORM_DATA: {
			if (action.response && !action.error) {
				const currentForm = Array.isArray(action.response) ? action.response[0] : action.response;
				const headersList = currentForm.headers?.map((header) => {
					return {
						id: header?.id,
						name: header?.name || header?.formHeaderName,
						isCustom: header?.isCustom,
						knowledgeDisplayOrder: header?.knowledgeDisplayOrder,
						engagementId: header?.engagementId,
						sections: header?.sections,
						knowledgeFormHeaderId: header?.knowledgeFormHeaderId || header?.knowledgeId,
						firstSectionId: header?.sections?.find((section) => section?.isDisplayed)?.id
					};
				});

				// Can this be done in the above map?
				const filteredHeadersList = headersList?.map((header) => {
					let hideHeaderFromSummary = false;
					if (header?.sections && header.sections?.length > 0) {
						hideHeaderFromSummary = header.sections?.every((section) => {
							return !section?.isDisplayed || section?.isSummaryTypeNone || section?.isSummary;
						});
					}
					return {
						...header,
						hideHeader:
							header.sections?.length === 0 ||
							header.sections?.every((section) => !section?.isDisplayed || section?.isSummary),
						hideHeaderFromSummary: hideHeaderFromSummary,
						hasSummarySection: header.sections?.some((section) => section?.isDisplayed && section?.isSummary),
						sections: header.sections ? header.sections?.map((section) => section?.id) : []
					};
				});

				// Get all section from all the form headers
				const allSections =
					headersList &&
					_.flatten(
						headersList?.map((header) =>
							header.sections?.map((section) => ({
								...section,
								name: section?.name || section?.formSectionName,
								knowledgeFormSectionId: section?.knowledgeId
							}))
						)
					)
						.filter((item) => item !== null)
						.map((section) => {
							if (section?.isDisplayed) {
								return {
									...section,
									isSummaryTypeNone: false
								};
							}

							return section;
						});

				newState = {
					guidanceAndGamLayer: currentForm?.guidanceAndGamLayer,
					knowledgeFormId: currentForm?.knowledgeFormId,
					parentSmartEvidenceSourceId: currentForm?.parentSmartEvidenceSourceId,
					isParentDocumentSignOff: currentForm?.isParentDocumentSignOff,
					headers: filteredHeadersList ? normalize(filteredHeadersList, undefined, state.headers) : state.headers,
					sections: allSections
						? normalize(allSections[0] !== undefined ? allSections : [], undefined, state.sections)
						: state.sections
				};
			}
			break;
		}
		case actionTypes.ARES_SET_SELECTED_HEADER: {
			newState = {
				...state,
				selectedFormHeader: action.headerId
			};
			break;
		}
		case actionTypes.ARES_CLEAR_FORM_HEADERS: {
			newState = {
				headers: normalize(),
				sections: normalize()
			};

			break;
		}
		default:
			return state;
	}

	return newState || state;
}

/// This function groups the sections for the header by knowledgeDisplayOrder
/// then sorts the sections with same knowledgeDisplayOrder with sectionId and then ungroups to return an array of sectionIds
function sortedSections(headerSections) {
	return Object.values(
		headerSections.reduce((acc, obj) => {
			const key = obj.knowledgeDisplayOrder;
			if (!acc[key]) {
				acc[key] = [];
			}
			acc[key].push(obj);
			return acc;
		}, {})
	)
		.map((group) => group.sort((a, b) => a.id - b.id))
		.flat();
}
